import React from "react";
import SundaranPortfolio from "./components";
import "./App.css";

function App() {
  return (
    <div className="App">
      <SundaranPortfolio />
    </div>
  );
}

export default App;
